import React from "react";

function ErrorPage({error}) {
    return <div>Error: {error}</div>
}

export default ErrorPage;